import axios from "axios";
import CryptoJS from "crypto-js";
import environment from "@/environment";
import { getRunTimeConfig, getProcessEnvConfig } from "@/environment";
import environmentVariables from '../../environmentVariables'

const client = axios.create({
  baseURL: environment.VUE_APP_API_URL,
  headers: { "X-Custom-Header": "foobar" },
});

function timeout(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export async function getEnvVariable(varName: string, retryTimes = 30) {
  let count = 0;

  do {
    const localEnv: any = await import("@/environment");
    const processEnvConfigObj: any = getProcessEnvConfig();
    const runTimeConfigObj: any = getRunTimeConfig();
    const variable =
      localEnv.default[varName] != undefined
        ? localEnv.default[varName]
        : processEnvConfigObj[varName] != undefined
        ? processEnvConfigObj[varName]
        : runTimeConfigObj[varName] != undefined
        ? runTimeConfigObj[varName]
        : undefined;

    if (variable != undefined) {
      return variable;
    } else {
      await timeout(1000);
      count++;
    }
  } while (count < retryTimes);

  return undefined;
}

client.interceptors.request.use(
  async function (config: any) {
    config.baseURL = await getEnvVariable("VUE_APP_API_URL");

    let token;
    const api_key = await getEnvVariable("VUE_APP_API_KEY", 5);

    if (config.method == "get") {
      // usa a url como token
      if (config.baseURL == undefined) return config;

      const baseUrl = config.baseURL.split("://")[1];
      const urlComplete = baseUrl + config.url.replaceAll(" ", "%20");
      token = CryptoJS.HmacSHA256(urlComplete, api_key).toString(CryptoJS.enc.Hex);
    } else {
      // usa o body como token
      token = CryptoJS.HmacSHA256(JSON.stringify(config.data), api_key).toString(CryptoJS.enc.Hex);
    }

    config.headers.authorization = token;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

client.interceptors.response.use(
  async function (config) {
    const VUE_APP_IS_PRODUCTION = await getEnvVariable("VUE_APP_IS_PRODUCTION");

    if (VUE_APP_IS_PRODUCTION === true)  {
      const appVersion = environmentVariables.APP_VERSION;
      const apiVersion = config.data.api_version;

      const [appMajor, appMinor, appPatch] = appVersion.split('.');
      const [apiMajor, apiMinor, apiPatch] = apiVersion.split('.');

      if (
          apiVersion && 
          appMajor === apiMajor &&
          appMinor === apiMinor &&
          appPatch === apiPatch
        ) {
        return config;
      } 
      return window.location.reload();
    }
    return config;
  }, function (error) {
    return Promise.reject(error);
  }
);


export default client;